// extracted by mini-css-extract-plugin
export default {"main":"styles_main__cWDqQ","skeleton":"styles_skeleton__J1vkf","skeleton_box":"styles_skeleton_box__niOBx","center":"styles_center__1eWGh","spacer":"styles_spacer__JAtSn"};